
export function open_email_attachment({ state }, link ){

    // adding token
    var token=state.appSettings.token
    link=link+"&token="+token;

    //var enc_link= link;
    var options="toolbar=yes,location=yes,usewkwebview=yes,closebuttoncaption=done";

    window.cordova.InAppBrowser.open(link, '_system', options);
    
  }